export default "__VITE_ASSET__a566cbe4__"